import { z } from 'zod';
import { investmentIdSchema } from './ids';

export const MAX_INVESTMENTS = 20;

/**
 * - `variant`: every item of the variant is the investment (a project that holds only the deal).
 * - `items`: only items tagged with this investment (`item.investment`), e.g. a rental flat
 *   inside a whole-life plan.
 */
export const INVESTMENT_SCOPES = ['variant', 'items'] as const;
export type InvestmentScope = (typeof INVESTMENT_SCOPES)[number];

/** A set of items analysed as one investment: IRR, profit and multiple of the money put in. */
export const investmentSchema = z.object({
  id: investmentIdSchema,
  name: z.string().trim().min(1).max(120),
  scope: z.enum(INVESTMENT_SCOPES),
});
export type Investment = z.infer<typeof investmentSchema>;
